import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function dispose() {
}
var HttpInterceptorClass;
function HttpInterceptor() {
  if (HttpInterceptorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HttpInterceptor', VOID, VOID, VOID, [2]);
    HttpInterceptorClass = $;
  }
  return HttpInterceptorClass;
}
var DefaultHttpInterceptorChainClass;
function DefaultHttpInterceptorChain() {
  if (DefaultHttpInterceptorChainClass === VOID) {
    class $ {
      constructor(interceptors, index) {
        this.interceptors_1 = interceptors;
        this.index_1 = index;
      }
      *proceed_voxjs5_k$(request, $completion) {
        // Inline function 'kotlin.check' call
        if (!(this.index_1 < this.interceptors_1.get_size_woubt6_k$())) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Check failed.');
        }
        return yield* this.interceptors_1.get_c1px32_k$(this.index_1).intercept_ut4154_k$(request, new (DefaultHttpInterceptorChain())(this.interceptors_1, this.index_1 + 1 | 0), $completion);
      }
    }
    initMetadataForClass($, 'DefaultHttpInterceptorChain', VOID, VOID, VOID, [1]);
    DefaultHttpInterceptorChainClass = $;
  }
  return DefaultHttpInterceptorChainClass;
}
//region block: exports
export {
  DefaultHttpInterceptorChain as DefaultHttpInterceptorChain22k3s5gesb9pu,
  dispose as dispose2t7a37uqicel0,
  HttpInterceptor as HttpInterceptor2khzkwmar9lg6,
};
//endregion

//# sourceMappingURL=HttpInterceptor.mjs.map
